import styled from '@emotion/styled'
import { WidgetContent, TextField, Select } from '@duik/it'
import DatePicker from 'react-datepicker'

export const StyledDatePicker = styled(DatePicker)`
  border: 1px solid #eaedf3 !important;
`

export const StyledWidget = styled(WidgetContent)`
  height: 355px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
`

export const MainContainer = styled.div`
  padding: 0 30px;
`

export const TopContainer = styled.div`
  padding-top: 20px;
`

export const FlexContainer = styled.div`
  display: flex;
`

export const ButtonContainer = styled.div`
  width: 83px;
`

export const ButtonWrapper = styled(WidgetContent)`
  display: flex;
  justify-content: space-between;
  border: none;
  width: 482px;
`

export const SelectWrapper = styled.div`
  margin-top: 10px;
`

export const ErrorText = styled.span`
  position: absolute;
  color: #e6492d;
  font-size: 0.75rem;
`
